"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var creator_ui_1 = require("@chameleoncreator/creator-ui");
var useSidebar_1 = require("../hooks/useSidebar");
exports.Block = function (props) {
    var ctx = react_1.useContext(useSidebar_1.EditContext);
    var onReturn = function () {
        ctx.popSidebarItem();
    };
    if (props.data.returnFocus) {
        onReturn = function () {
            ctx.popSidebarItem();
            props.data.returnFocus();
        };
    }
    var ref = react_1.useRef(null);
    react_1.useEffect(function () {
        if (ref.current && props.data.returnFocus) {
            ref.current.focus();
        }
    }, [props.data]);
    return (react_1.default.createElement(creator_ui_1.Box, null,
        react_1.default.createElement(creator_ui_1.Button, { onClick: onReturn, ref: ref },
            react_1.default.createElement(creator_ui_1.BackIcon, null),
            " Back"),
        react_1.default.createElement(creator_ui_1.Heading, { as: "h3" },
            "Editing Block: ",
            props.data.block.type)));
};
